export default __webpack_public_path__ + "static/media/joywake.821a73c6.png";